import { useCallback, useEffect, useRef, useState } from 'react';
import { VOCABULARY_LIMIT_MS } from '../services/VocabularyLearningSession';
export { VOCABULARY_LIMIT_MS, VOCABULARY_SCORING_RULE_VERSION } from '../services/VocabularyLearningSession';

export function clearVocabularySessionCache() {
  try {
    Object.keys(sessionStorage).filter(key => /^vocabulary-(operation|clock|face|last-session)/.test(key))
      .forEach(key => sessionStorage.removeItem(key));
  } catch { /* Legacy cache cleanup must not block learning. */ }
}

export default function useVocabularyTimer(session, { paused = false } = {}) {
  const clock = useRef({ id: session?.id, elapsedMs: 0, since: performance.now(), running: false });
  const [elapsedMs, setElapsedMs] = useState(0);
  const sample = useCallback((display = true) => {
    const current = clock.current;
    const now = performance.now();
    if (current.running) current.elapsedMs = Math.min(VOCABULARY_LIMIT_MS, current.elapsedMs + Math.max(0, now - current.since));
    current.since = now;
    if (display) setElapsedMs(Math.floor(current.elapsedMs));
    return { elapsedMs: Math.floor(current.elapsedMs) };
  }, []);
  useEffect(() => {
    if (clock.current.id !== session?.id) clock.current = { id: session?.id, elapsedMs: 0, since: performance.now(), running: false };
    sample();
    clock.current.running = session?.status === 'active' && session?.phase === 'learning' && !paused && !document.hidden;
  }, [session?.id, session?.status, session?.phase, paused, sample]);
  useEffect(() => {
    const visibility = () => {
      sample();
      clock.current.running = session?.status === 'active' && session?.phase === 'learning' && !paused && !document.hidden;
    };
    const interval = setInterval(sample, 250);
    document.addEventListener('visibilitychange', visibility);
    return () => { sample(false); clock.current.running = false; clearInterval(interval); document.removeEventListener('visibilitychange', visibility); };
  }, [session?.status, session?.phase, paused, sample]);
  const discard = useCallback(() => { clock.current.running = false; clock.current.elapsedMs = 0; setElapsedMs(0); }, []);
  return { elapsedMs, elapsedSeconds: Math.floor(elapsedMs / 1000), snapshot: () => sample(false), discard };
}
